import { render, staticRenderFns } from "./Ineligible.vue?vue&type=template&id=12775a52&"
import script from "./Ineligible.vue?vue&type=script&lang=js&"
export * from "./Ineligible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports